module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-page create-page mx-5"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('drag-file-uploader', {
    ref: "dragFileUploader",
    attrs: {
      "accept": "mp3/*",
      "type": "file",
      "category": "audio",
      "autoUpload": true
    },
    on: {
      "filePicked": _vm.pickedFile
    }
  })], 1), _vm._v(" "), (_vm.album.tracks.length) ? _c('div', {
    staticClass: "track-list-section"
  }, [_c('h4', {
    staticClass: "track-list-title",
    attrs: {
      "id": "track_list"
    }
  }, [_vm._v("Tracklist")]), _vm._v(" "), _c('draggable', {
    staticClass: "track-items",
    attrs: {
      "handle": ".item-handle"
    },
    model: {
      value: (_vm.album.tracks),
      callback: function($$v) {
        _vm.$set(_vm.album, "tracks", $$v)
      },
      expression: "album.tracks"
    }
  }, [_c('transition-group', _vm._l((_vm.album.tracks), function(file, index) {
    return _c('div', {
      key: index,
      staticClass: "track-item"
    }, [_c('label', {
      staticClass: "item-index pl-3"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "item-section"
    }, [_c('img', {
      staticClass: "item-handle",
      attrs: {
        "width": "18",
        "src": "/static/images/t-menu.svg",
        "alt": ""
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (file.file_name),
        expression: "file.file_name"
      }],
      staticClass: "item-name",
      attrs: {
        "type": "text",
        "disabled": file.status != _vm.status.success,
        "placeholder": "Track name"
      },
      domProps: {
        "value": (file.file_name)
      },
      on: {
        "focus": function($event) {
          _vm.onInputFocus(index, $event)
        },
        "blur": function($event) {
          _vm.onInputBlur(index, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(file, "file_name", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-center ml-2 pl-2 download-price"
    }, [_c('i', {
      staticClass: "fa fa-usd",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (file.download_price),
        expression: "file.download_price"
      }],
      staticClass: "item-name",
      attrs: {
        "type": "text",
        "disabled": file.status != _vm.status.success,
        "placeholder": "Set download price ($1 - $1000)"
      },
      domProps: {
        "value": (file.download_price)
      },
      on: {
        "focus": function($event) {
          _vm.onInputFocus(index, $event)
        },
        "blur": function($event) {
          _vm.onInputBlur(index, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(file, "download_price", $event.target.value)
        }
      }
    })]), _vm._v(" "), (file.status == _vm.status.uploading) ? _c('v-progress-circular', {
      staticClass: "primary--text loading",
      attrs: {
        "indeterminate": "",
        "size": 20
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "action-btns"
    }, [(file.status == _vm.status.success) ? _c('v-icon', {
      staticClass: "done"
    }, [_vm._v("done")]) : _vm._e(), _vm._v(" "), (file.status == _vm.status.failed) ? _c('v-icon', {
      staticClass: "failed"
    }, [_vm._v("error_outline")]) : _vm._e(), _vm._v(" "), (file.status != _vm.status.uploading) ? _c('v-icon', {
      staticClass: "clear-btn",
      on: {
        "click": function($event) {
          _vm.deleteTrack(index)
        }
      }
    }, [_vm._v("clear")]) : _vm._e()], 1)], 1)])
  }))], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_unauthorized_content_dialog),
      callback: function($$v) {
        _vm.show_unauthorized_content_dialog = $$v
      },
      expression: "show_unauthorized_content_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Unauthorized audio content")]), _vm._v(" "), _c('div', [_vm._v("\n          The song\n          "), _c('span', {
    staticClass: "blue--text"
  }, [_vm._v(_vm._s(_vm.currentFile.track_title))]), _vm._v(" by\n          "), _c('span', {
    staticClass: "blue--text"
  }, [_vm._v(_vm._s(_vm.currentFile.artist_name))]), _vm._v(" was\n          detected in your upload. Please delete any unauthorized tracks in\n          your album to complete your upload. if you find this message, please\n          contact support.\n        ")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_unauthorized_content_dialog = false
      }
    }
  }, [_vm._v("Return to upload page")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelTrack()
      }
    }
  }, [_vm._v("Cancel Upload")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_duplicate_content_dialog),
      callback: function($$v) {
        _vm.show_duplicate_content_dialog = $$v
      },
      expression: "show_duplicate_content_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Duplicate upload")]), _vm._v(" "), _c('div', [_vm._v("\n          The song\n          "), _c('span', {
    staticClass: "blue--text"
  }, [_vm._v(_vm._s(_vm.currentFile.track_title))]), _vm._v(" by\n          "), _c('span', {
    staticClass: "blue--text"
  }, [_vm._v(_vm._s(_vm.currentFile.artist_name))]), _vm._v(" was\n          detected in your upload. Only one copy of a song can exist on\n          YouSound. If you are a collaborator on this song, contact the\n          original uploader and request to add yourself as a collaborator then\n          re-upload the album. Please delete any duplicate tracks in your\n          album to complete your upload.\n        ")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_duplicate_content_dialog = false
      }
    }
  }, [_vm._v("Return to upload page")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelTrack()
      }
    }
  }, [_vm._v("Cancel Upload")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d6f552a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/trackuploader.vue
// module id = 1635
// module chunks = 180